import React from 'react';

interface Props {
    text: string;
}

const Message = (props: Props) => <p>{props.text}</p>;

export default React.memo(Message);
